export default __webpack_public_path__ + "static/media/vision.d3391053.svg";